// extracted by css-extract-rspack-plugin
export default {"cls1":"AccountMenu-cls1_RMn","cls2":"AccountMenu-cls2_m-w AccountMenu-cls1_RMn"};